import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useGetPersonsByGroupDropdownQuery  } from '../../../../api/endpoints/teamProductivityMeasurement';
import { useLanguage } from '../../../../contexts/LanguageContext';

const PersonByGroupDropdown = ({ senderLookupId, value, onChange, className = '', disabled = false }) => {
    const { th, getCurrentLanguageId } = useLanguage();
    const languageId = getCurrentLanguageId();

    const { data: persons = [], isLoading } = useGetPersonsByGroupDropdownQuery ({ senderLookupId, languageId }, { skip: !senderLookupId });

    const options = persons.map((p) => ({
        label: p.firstLastName,
        value: p.firstLastName
    }));

    return (
        <Dropdown
            value={value || null}
            options={options}
            onChange={(e) => onChange(e.value || '')}
            optionLabel="label"
            optionValue="value"
            className={className}
            placeholder={th('teamProductivity.placeholders.requestSenderName')}
            loading={isLoading}
            disabled={disabled}
            filter
            showClear
            emptyMessage={th('common.noRecordsFound')}
        />
    );
};

export default PersonByGroupDropdown;
